/**
 * TEMPORARY — Fixdesk ("Fixer Platz pro Monat") UI overrides.
 *
 * The hosted listing type "Fixer Platz pro Monat" (fixdesk) currently runs on the
 * default-purchase process (unitType `item`, pickup enabled). That makes the stock
 * UI talk about products: the ListingCard shows a bare price without "pro Monat",
 * and the OrderPanel shows "Versandmethode: Abholung/Übergabe". The helpers below
 * let those places detect a fixdesk listing and render membership wording instead.
 *
 * Migration path (why this is temporary): the target model is the existing
 * `cowork24-abo` listing type / process (subscription with monthly billing, see
 * src/config/configListing.js and src/transactions/transactionProcessAbo.js).
 * Once fixdesk listings are recreated/migrated onto `cowork24-abo`,
 * `isFixdeskListing` returns false (the purchase-process gate below stops
 * matching) and the Abo UI takes over automatically — this module and every
 * `isFixdeskListing` call site can then be deleted.
 */
import { isPurchaseProcessAlias } from '../transactions/transaction';

// Same loose spelling/casing tolerance as the space-type matchers in
// components/CategoryShortcuts/categoryGroups.js, but anchored to the start
// so an unrelated future type id merely CONTAINING the pattern can't match.
const FIXDESK_LISTING_TYPE_MATCHER = /^fix(ed)?[\s._-]?desk/i;

/**
 * @param {Object} publicData listing.attributes.publicData
 * @returns {boolean} true when the listing is a purchase-process fixdesk listing
 *   that needs the temporary "Fixer Platz pro Monat" wording.
 */
export const isFixdeskListing = publicData => {
  const { listingType, transactionProcessAlias } = publicData || {};
  return (
    isPurchaseProcessAlias(transactionProcessAlias) &&
    FIXDESK_LISTING_TYPE_MATCHER.test(listingType || '')
  );
};
